import { useApi } from "../../api/hooks/use-api.ts";
import { ApiResponseType } from "../../api/types.ts";
import { ApiMethod } from "../../api/types.ts";
import { withArrayPayload, withObjectPayload } from "../../api/payload.ts";

export const useDocumentApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is the document array. Error: payload is the error object
    // (e.g. 403 role_not_validated: { error, message }).
    const getDocuments = async () => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=documents');

        return response.then(withArrayPayload);
    };

    // OK: payload is { payload: <base64>, content_type }.
    const getDocument = async (path) => {
        if (typeof path === 'string') {
            path = {
                'path': path
            }
        }
        const response = sendProtectedRequest(ApiMethod.POST, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=document', path);

        return response.then(withObjectPayload);
    };

    const getVideoStreamUrl = async (path: string): Promise<string | null> => {
        const response = await sendProtectedRequest(
            ApiMethod.POST,
            process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=videoToken',
            { path }
        ).then(withObjectPayload);

        if (response.type !== ApiResponseType.OK || !response.payload.token) {
            return null;
        }

        const params = new URLSearchParams({
            token: process.env.REACT_APP_FPSB_PORTAL_TOKEN || '',
            action: 'video',
            path,
            vtoken: response.payload.token,
        });

        return `${process.env.REACT_APP_FPSB_PORTAL_BASE_URL}${process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT}&${params.toString()}`;
    };

    // Fetch a configured legal document (agb / privacy / withdrawal / exam_regulations)
    // as { payload: <base64>, content_type }. Available to pending advisors
    // (unlike the document center).
    const getVerificationDocument = async (key:string) => {
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=verificationDocument&key=' + encodeURIComponent(key));

        return response.then(withObjectPayload);
    };

    return { getDocuments, getDocument, getVideoStreamUrl, getVerificationDocument };
};
